import { Button as MUIButton } from "@mui/material";
import Backbutton from "assets/backbutton";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Stepper from "components/common/Stepper";
import { useContext, useEffect, useState } from "react";

import { postUserVisit } from "components/app/App.slice";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import { reset } from "components/features/PlanAssignment/PlanAssignment.slice";
import PlanSelection from "components/features/PlanAssignment/PlanSelection";
import { isEmpty, isUndefined } from "lodash";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { responseTypes } from "utils/Types";
import { commonApiCallParam, getLoggedInUserDetails, updatePopupHeader } from "utils/UserAnalyticsUtils";
import { postSuggestedPlansAsync, setAssignmentPopupOpen, setPayloadData } from "../ManageSuggestions.slice";
import AssignmentDetails from "./assignmentDetails";
import "./index.scss";

const SuggestedPlansModal = (props: any) => {
  const { handleClose } = props;

  const dispatch = useAppDispatch();

  const isAssignmentPopupOpen = useAppSelector((state) => state.manageSuggestions.isAssignmentPopupOpen);
  const selectedSuggestedInncodes = useAppSelector((state) => state.manageSuggestions.selectedSuggestedInncodes);

  const [currentStep, setCurrentStep] = useState<number>(0);
  const { isOpenPlanDetailDialog } = useContext(ActionCardDialogsContext);
  const { isOpenViewActionDialog } = useContext(ActionCardDialogsContext);

  const flow = ["Plan Selection", "Expiration Date", "Confirmation"];

  const {
    payloadData: { plans }
  } = useAppSelector((state) => state.manageSuggestions);

  const headingFlow: any = {
    "0": "Suggested Plan(s) - Plan Selection",
    "1": "Suggested Plan(s) - Expiration Date",
    "2": "Suggested Plan(s) - Confirmation"
  };

  useEffect(() => {
    if (currentStep < 1 && !isEmpty(headingFlow?.[currentStep])) {
      const userDetails = getLoggedInUserDetails();
      if (!isEmpty(userDetails)) {
        const params = commonApiCallParam(true);
        const param = updatePopupHeader(`${headingFlow?.[currentStep] || ""}`);
        params.popupHeader = param;
        dispatch(postUserVisit(params));
      }
    }
  }, [getLoggedInUserDetails, headingFlow?.[currentStep]]);

  useEffect(() => {
    if (currentStep > 0 && !isUndefined(headingFlow?.[currentStep])) {
      const userDetails = getLoggedInUserDetails();
      if (!isEmpty(userDetails)) {
        const params = commonApiCallParam(true);
        const param = updatePopupHeader(`${headingFlow?.[currentStep] || ""}`);
        params.popupHeader = param;
        dispatch(postUserVisit(params));
      }
    }
  }, [getLoggedInUserDetails, currentStep]);

  const renderComponent = (): JSX.Element | null => {
    const innCode = selectedSuggestedInncodes.length > 1 ? DEFAULT_CORP_INNCODE : selectedSuggestedInncodes?.[0];
    switch (currentStep) {
      case 0:
        return (
          <PlanSelection
            inncodes={innCode}
            targetClass="actionItemsDivMobile"
            setPayloadData={setPayloadData}
            showToggle={false}
            plans={plans}
            shouldHideTargetingFilters
          />
        );
      case 1:
        return <AssignmentDetails isEdit={true} />;
      case 2:
        return <AssignmentDetails />;

      default:
        return <></>;
    }
  };

  const checkExpiryDate = () => {
    const isExpiryDate = plans.some((item: any) => isEmpty(item?.expiryDate));
    return isExpiryDate;
  };

  const isDisabled = () => {
    switch (currentStep) {
      case 0:
        return !plans?.length;
      case 1:
        return checkExpiryDate();
    }
    return false;
  };

  const formPayload = () => {
    const inncodes = selectedSuggestedInncodes.map((inncodes: any) => inncodes);
    const suggestions = plans.map((suggestion: any) => {
      return {
        cmsId: suggestion.id,
        expiryDate: suggestion?.expiryDate,
        priority: suggestion?.priority ?? "Bottom"
      };
    });
    return { inncodes, suggestions };
  };

  const handleFeedbackDetail = (variant: string, message: string) => {
    dispatch(
      setFeedbackDetails({
        shouldShow: true,
        variant: variant,
        setState: setFeedbackDetails({ shouldShow: false }),
        message: message
      })
    );
  };

  const handleApplySuggestions = async () => {
    const resp = await dispatch(postSuggestedPlansAsync(formPayload()));
    const apiResponse = resp.payload;
    if (apiResponse.status === responseTypes.created || apiResponse.status === responseTypes.partial_content) {
      handleFeedbackDetail("success", apiResponse?.message);
      dispatch(reset());
      handleClose();
    } else if (apiResponse.response.status === responseTypes.error) {
      handleFeedbackDetail("error", apiResponse?.response?.data?.message);
    }
  };

  return (
    <div className="suggested-plans-tab">
      {isAssignmentPopupOpen && (
        <DialogFormation
          title="Select Suggested Plan(s)"
          openDialog={isAssignmentPopupOpen}
          parentClass={`suggested-plans-tab-modal ${isOpenViewActionDialog || isOpenPlanDetailDialog ? "d-none" : ""}`}
          isFullscreen={true}
          handleClose={() => {
            dispatch(reset());
            handleClose();
            dispatch(setAssignmentPopupOpen(false));
          }}
          preventPageApi={true}
          actionConfig={
            <div className="modal-config-wrapper-with-back vertical-center ">
              <div className="action-config-text">
                {currentStep > 0 && (
                  <MUIButton
                    sx={{
                      paddingLeft: "0px",
                      gap: "8px",
                      display: "flex",
                      alignItems: "center",
                      marginY: { xs: "0", md: "unset" }
                    }}
                    onClick={() => setCurrentStep(currentStep - 1)}
                    variant="text"
                  >
                    <Backbutton color={tokens.Text.General.Color}></Backbutton>
                    <Typography color={tokens.Text.General.Color} children="Back" variant="body1" />
                  </MUIButton>
                )}
              </div>
              <div className="action-config-button suggested-plans-action">
                <Button
                  variant="secondary"
                  label="Cancel"
                  className="cancel-modal"
                  onClick={() => {
                    dispatch(reset());
                    handleClose();
                    dispatch(setAssignmentPopupOpen(false));
                  }}
                />
                {currentStep !== 2 ? (
                  <Button
                    variant="primary"
                    label="Next"
                    disabled={isDisabled()}
                    endIcon={
                      currentStep === 0 &&
                      plans.length > 0 && (
                        <div className="next-count">
                          <Typography className="count-badge" variant={"body2"} showBold>
                            {plans.length}
                          </Typography>
                        </div>
                      )
                    }
                    onClick={() => setCurrentStep(currentStep + 1)}
                  />
                ) : (
                  <Button variant="primary" label="Submit Suggested Plan(s)" onClick={handleApplySuggestions} />
                )}
              </div>
            </div>
          }
        >
          <Stepper
            flow={flow}
            currentStep={currentStep}
            setCurrentStep={(index: number) => setCurrentStep(index)}
            color={tokens.Text.General.Secondary}
          />

          <div className="render-components">{renderComponent()}</div>
        </DialogFormation>
      )}
    </div>
  );
};

export default SuggestedPlansModal;
